import type { ReactNode } from "react";
import type { RowState } from "./types";

type Props = {
  row: RowState;
  children?: ReactNode;
};

export function TableRow({ row, children }: Props) {
  return <tr style={{ height: row.height }} children={children} />;
}
